module.exports = __webpack_public_path__ + "img/funeral-brochure.9a93f4ce.jpg";